import { createContext, useContext } from "react";

import { UserMe, Token } from "shared/models";
import { CFC } from "shared/types";

import { useAuth } from "./useAuth";

type AuthContextType = ReturnType<typeof useAuth>;

const AuthContext = createContext<AuthContextType>({
  user: new UserMe(),
  userToken: new Token(),
  token: "",
  accessToken: "",
  signIn: () => void(0),
  signOut: () => void(0),
  refetch: () => void(0),
  setOnlyToken: () => void(0),
  waitToken: () => Promise.resolve(""),
  isIdle: true,
  isSignedIn: false,
  isLoading: false,
  isAccidentallySignedOut: false,
});

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider: CFC = ({ children }) => {
  const value = useAuth();

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
